import { memo } from 'react';
import { Icon } from '@amzn/awsui-components-core';

import styles from './ContentNavigator.module.scss';
import EditPageModal from './EditPageModal';
import { useEditPageButtonViewModel } from './EditPageButtonViewModel';

/** Icon button + modal for reordering pages of a Guide document. */
const EditPageButton = memo(function EditPageButton() {
  const vm = useEditPageButtonViewModel();

  return (
    <>
      <button
        type="button"
        className={styles.editIconButton}
        aria-label="Re-order Pages"
        onClick={vm.openModal}
      >
        <Icon name="edit" />
      </button>
      {vm.isModalVisible && <EditPageModal vm={vm} />}
    </>
  );
});

export default EditPageButton;
